import { Icon } from '@uag/react-core';
import { clsx } from 'clsx';

type PasswordRequirementProps = {
    requirement: string;
    fulfills: boolean;
    disabled: boolean;
};

export const PasswordRequirement = ({ requirement, fulfills, disabled }: PasswordRequirementProps) => {
    const fulfilled = !disabled && fulfills;
    const notFulfilled = !disabled && !fulfills;

    return (
        <div
            className={clsx(
                'flex items-center gap-1 text-sm',
                disabled && 'text-text-ultra-light',
                fulfilled && 'text-text-success',
                notFulfilled && 'text-text-alert',
            )}
        >
            {disabled && <Icon icon="circle" size="lg" />}
            {fulfilled && <Icon icon="check_circle" size="lg" />}
            {notFulfilled && <Icon icon="cancel" size="lg" />}
            {requirement}
        </div>
    );
};
